import { render, staticRenderFns } from "./CiLanguageChooser.vue?vue&type=template&id=214a0dc0&scoped=true&"
import script from "./CiLanguageChooser.vue?vue&type=script&lang=js&"
export * from "./CiLanguageChooser.vue?vue&type=script&lang=js&"
import style0 from "./CiLanguageChooser.vue?vue&type=style&index=0&id=214a0dc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214a0dc0",
  null
  
)

component.options.__file = "CiLanguageChooser.vue"
export default component.exports